/**
 * Navigation utility functions.
 * Provides helpers for navigation-related functionality.
 *
 * @module utils/navigation
 */

import { HOLIDAY_RED_COLOR_CODE, SITE_HEADER_NAV_SKIN_HOLIDAY } from '../constants/styles'

/**
 * Checks if the given theme is the holiday theme.
 *
 * @param theme - The theme identifier to check
 * @returns True if the theme matches the holiday skin, false otherwise
 *
 * @example
 * isThemeHoliday('site-header-nav-skin-holiday') // returns true
 * isThemeHoliday('default') // returns false
 */
export const isThemeHoliday = (theme: string): boolean => {
  return theme === SITE_HEADER_NAV_SKIN_HOLIDAY
}

export const getHolidayThemeStyles = (theme?: string): React.CSSProperties => {
  if (!theme || !isThemeHoliday(theme)) return {}

  return { color: HOLIDAY_RED_COLOR_CODE }
}
